import * as moment from 'moment';

export class DateUtils {

  static endOfDay(date: moment.MomentInput): moment.Moment | null {
    if (date) {
      return moment(date).endOf('day');
    }
    return null;
  }

  static serializeDateWithoutTimeZone(date: moment.MomentInput): string | null {
    return DateUtils.format(date, 'YYYY-MM-DD');
  }

  static serializeDateWithTimeZone(date: moment.MomentInput): string | null {
    if (date) {
      return moment(date).toISOString();
    }
    return null;
  }

  static formatDate(date: moment.MomentInput): string | null {
    return DateUtils.format(date, 'YYYY-MM-DD');
  }

  static formatDateTime(date: moment.MomentInput): string | null {
    return DateUtils.format(date, 'YYYY-MM-DD HH:mm');
  }

  static format(date: moment.MomentInput, format: string): string | null {
    if (date) {
      return moment(date).format(format);
    }
    return null;
  }

  static formatDateObject(date: Date): string {
    return `${date.getFullYear()}-${(date.getMonth() + 1) < 10 ? '0' : ''}${date.getMonth() + 1}-${date.getDate() < 10 ? '0' : ''}${date.getDate()}`;
  }
}
